import React from 'react';

import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

const CtaCourseCard = () => {
  return (
    <Container className='d-flex justify-content-center'>
      <Card style={{ borderRadius: 70 }} className='shadow-sm contact-card-width border-action-card mx-3 mx-md-5 my-3'>
        <Card.Body>
          <Row className='custom-vertical-align'>
            <Col xs={12} className='pl-md-5 mb-0'>
              <Card.Text className='text-center'>
                Forma parte de la comunidad de aprendizaje lider en Ecuador y potencia tu perfil personal y profesional.
              </Card.Text>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CtaCourseCard;
